import { useSearchParams } from "react-router-dom";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import {
  MASONRY,
  SCREENINGS_SCHEDULE_CONTENT_MAX_WIDTH,
} from "common/constants";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { ModalScreenHeader } from "components/modal-screen-header/modal-screen-header.component";

export const ScheduleAppointmentPage = () => {
  const [searchParams] = useSearchParams();
  const locationCode = searchParams.get("locationCode") ?? "";
  const locationName = searchParams.get("locationName") ?? "";
  const programId = searchParams.get("programId") ?? "";

  usePageViewAnalytics({ screen_name: "Schedule Appointment" });
  const { formatMessage } = useIntl();
  useDocumentTitle(
    formatMessage({ id: "STR_SCREENINGS_SCHEDULE_APPOINTMENT" })
  );

  return (
    <PageContentWrapper>
      <ModalScreenHeader
        backLabel={locationName}
        closeTo={APP_MANAGED_ROUTES.SCREENINGS}
        analyticsEventProps={{ screen_name: "Schedule Appointment" }}
        css={{
          maxWidth: SCREENINGS_SCHEDULE_CONTENT_MAX_WIDTH,
          marginInline: "auto",
        }}
      />
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_SCREENINGS_SCHEDULE}
        initialQueryParams={{ locationCode, locationName, programId }}
      />
    </PageContentWrapper>
  );
};
